import { ToolUIPart } from 'ai';

import { normalizeToolName } from './utils';

import { PathwayUITools } from '@/routes/smart-search/types';

export const createSummaryTitle = (part: ToolUIPart<PathwayUITools>) => {
  switch (part.type) {
    case 'tool-search':
      return createSearchSummaryTitle(part);
    default:
      return normalizeToolName(part.type);
  }
};

const createSearchSummaryTitle = (
  part: ToolUIPart<Pick<PathwayUITools, 'search'>>,
) => `Searched "${part.input?.query}"`;
